import { Reveal } from "@/components/site/Reveal";
import { Smartphone, Globe, ClipboardList, Lock } from "lucide-react";

const FEATURES = [
  { icon: ClipboardList, title: "Fully personalised", desc: "Programmes built around your goals, equipment and schedule — not a generic plan." },
  { icon: Smartphone, title: "Your own client app", desc: "Every workout uploaded to your personal app, with demos, sets and tracking." },
  { icon: Lock, title: "Private login", desc: "Your own secure login — your training, progress and notes in one place." },
  { icon: Globe, title: "Anywhere on earth", desc: "Nationwide and worldwide. If you've got a phone and the will, we can work." },
];

export const OnlineCoaching = () => (
  <section id="online" className="py-20 md:py-28 bg-[#0F172A] border-y border-white/10">
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <div className="rounded-[2rem] border border-[#2563EB]/30 bg-[#020617]/60 p-8 md:p-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <Reveal className="lg:col-span-6">
            <span className="font-mono-label text-[11px] text-[#2563EB]">Not in Essex?</span>
            <h2 className="font-display font-bold text-4xl sm:text-5xl mt-4">
              Online coaching, <span className="text-[#FACC15]">anywhere.</span>
            </h2>
            <p className="text-[#94A3B8] mt-5 text-base md:text-lg leading-relaxed max-w-xl">
              Mobile training is my focus, but online clients are welcome too — nationwide and
              worldwide. You get fully personalised workouts inside your own private client app,
              uploaded and adjusted by me as you progress.
            </p>
            <button
              onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
              data-testid="online-cta"
              className="mt-8 font-mono-label text-[11px] border border-white/25 text-[#F8FAFC] px-7 py-4 rounded-full hover:border-[#FACC15] hover:text-[#FACC15] transition-colors duration-300"
            >
              Enquire about online coaching
            </button>
          </Reveal>

          <div className="lg:col-span-6 grid sm:grid-cols-2 gap-4">
            {FEATURES.map((f, i) => {
              const Icon = f.icon;
              return (
                <Reveal key={i} delay={i * 0.07}>
                  <div data-testid={`online-feature-${i}`} className="p-5 rounded-2xl border border-white/10 h-full hover-lift hover:-translate-y-1">
                    <Icon size={22} className="text-[#FACC15]" />
                    <h3 className="font-display text-lg mt-3">{f.title}</h3>
                    <p className="text-[#94A3B8] text-sm mt-1.5 leading-relaxed">{f.desc}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  </section>
);
